<cap-power-bi-report *ngIf="reportID && stopLoading" [reportId]="reportID" [reportPage]="reportPageName" tokenEndpoint="/dashboard-rmc/report">
</cap-power-bi-report>

<div *ngIf="!reportID && stopLoading">{{ 'dashboard-rmc.dashboard-reports.report-not-found.label' | translate }}</div>

<ng-template *ngIf="!stopLoading">
    <app-loader></app-loader>
</ng-template>
